import { BlankButton } from "./blank-button";

type Props = {
	onRemoveLocationTag: () => void;
	regionWithPrefectureSelectFieldChildren: React.ReactNode;
	citySelectFieldChildren: React.ReactNode;
};
export const LocationTagSection = ({
	onRemoveLocationTag,
	regionWithPrefectureSelectFieldChildren,
	citySelectFieldChildren,
}: Props) => {
	return (
		<div className="space-y-1">
			<div className="flex items-center gap-x-3">
				<p>地名タグ</p>

				<BlankButton onClickCallback={onRemoveLocationTag} />
			</div>

			<div className="space-y-3">
				{/* 地域/都道府県 */}
				{regionWithPrefectureSelectFieldChildren}

				{/* 都市 */}
				{citySelectFieldChildren}
			</div>
		</div>
	);
};
